/**
 * Help Center Content — Spanish
 *
 * Exporta todas las categorías y artículos para la localización en español
 */

// Categories
export { HELP_CATEGORIES_ES, getCategoryByIdEs } from "./categories";

// Articles
export { GETTING_STARTED_ARTICLES_ES } from "./articles/getting-started";
export { ACCOUNT_ARTICLES_ES } from "./articles/account";
export { DEPOSITS_ARTICLES_ES } from "./articles/deposits";
export { WITHDRAWALS_ARTICLES_ES } from "./articles/withdrawals";
export { TRANSACTIONS_ARTICLES_ES } from "./articles/transactions";
export { LIMITS_FEES_ARTICLES_ES } from "./articles/limits-fees";
export { SECURITY_ARTICLES_ES } from "./articles/security";
export { TROUBLESHOOTING_ARTICLES_ES } from "./articles/troubleshooting";

import type { HelpArticle, HelpCategory } from "../../types";

import { HELP_CATEGORIES_ES } from "./categories";
import { GETTING_STARTED_ARTICLES_ES } from "./articles/getting-started";
import { ACCOUNT_ARTICLES_ES } from "./articles/account";
import { DEPOSITS_ARTICLES_ES } from "./articles/deposits";
import { WITHDRAWALS_ARTICLES_ES } from "./articles/withdrawals";
import { TRANSACTIONS_ARTICLES_ES } from "./articles/transactions";
import { LIMITS_FEES_ARTICLES_ES } from "./articles/limits-fees";
import { SECURITY_ARTICLES_ES } from "./articles/security";
import { TROUBLESHOOTING_ARTICLES_ES } from "./articles/troubleshooting";

/**
 * All Spanish articles combined
 */
export const ALL_ARTICLES_ES: HelpArticle[] = [
  ...GETTING_STARTED_ARTICLES_ES,
  ...ACCOUNT_ARTICLES_ES,
  ...DEPOSITS_ARTICLES_ES,
  ...WITHDRAWALS_ARTICLES_ES,
  ...TRANSACTIONS_ARTICLES_ES,
  ...LIMITS_FEES_ARTICLES_ES,
  ...SECURITY_ARTICLES_ES,
  ...TROUBLESHOOTING_ARTICLES_ES,
];

/**
 * Get articles by category (Spanish)
 */
export function getArticlesByCategoryEs(categoryId: string): HelpArticle[] {
  return ALL_ARTICLES_ES.filter((article) => article.category === categoryId).sort(
    (a, b) => a.order - b.order
  );
}

/**
 * Get article by slug (Spanish)
 */
export function getArticleBySlugEs(slug: string): HelpArticle | undefined {
  return ALL_ARTICLES_ES.find((article) => article.slug === slug);
}

/**
 * Get article by ID (Spanish)
 */
export function getArticleByIdEs(id: string): HelpArticle | undefined {
  return ALL_ARTICLES_ES.find((article) => article.id === id);
}

/**
 * Get popular articles (Spanish)
 */
export function getPopularArticlesEs(): HelpArticle[] {
  return ALL_ARTICLES_ES.filter((article) => article.popular);
}

/**
 * Search articles (Spanish)
 */
export function searchArticlesEs(query: string): HelpArticle[] {
  const lowercaseQuery = query.toLowerCase();
  return ALL_ARTICLES_ES.filter(
    (article) =>
      article.title.toLowerCase().includes(lowercaseQuery) ||
      article.description.toLowerCase().includes(lowercaseQuery) ||
      article.keywords.some((keyword) =>
        keyword.toLowerCase().includes(lowercaseQuery)
      ) ||
      article.content.toLowerCase().includes(lowercaseQuery)
  );
}

/**
 * Get category with articles (Spanish)
 */
export function getCategoryWithArticlesEs(
  categoryId: string
): { category: HelpCategory; articles: HelpArticle[] } | undefined {
  const category = HELP_CATEGORIES_ES.find((cat) => cat.id === categoryId);
  if (!category) return undefined;

  const articles = getArticlesByCategoryEs(categoryId);
  return { category, articles };
}
